import Modal from 'LuxKit/Modal/Modal'
import { useCallback, useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { semiFormToObject } from 'lib/forms/formUtils'
import type {
  CruiseSearchShipChipProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchShipChip'
import CruiseShipFilter
  from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruiseShipFilter'
import useQueryParams from 'hooks/useQueryParams'

function ModalCruiseSearchShipChip(props: CruiseSearchShipChipProps) {
  const {
    facets,
    filterForm,
    setFilterForm,
    fetching,
    filters,
    drawerMode,
  } = props
  const intl = useIntl()
  const modalElement = useModalElementContext<number>()
  const containerRef = useRef<HTMLDivElement>(null)
  const queryParams = useQueryParams()

  const queryParamCruiseShips = useMemo(() => {
    return queryParams.getAll('cruiseShips')
  }, [queryParams])

  const countSelected = useMemo(() => {
    return queryParamCruiseShips.length || 0
  }, [queryParamCruiseShips.length])

  const closeModal = useCallback(() => {
    modalElement.resolve(countSelected)
  }, [countSelected, modalElement])

  const updateForm = useCallback(() => {
    if (containerRef.current) {
      const formValues = semiFormToObject<Record<string, any>>(containerRef.current)
      if (formValues && Object.keys(formValues).length > 0) {
        setFilterForm({ ...filterForm, ...formValues })
      } else {
        setFilterForm({ ...filterForm, cruiseShips: undefined })
      }
    }
  }, [filterForm, setFilterForm])

  const resetFilter = useCallback(() => {
    setFilterForm({ ...filterForm, cruiseShips: undefined })
    modalElement.resolve(0)
  }, [setFilterForm, filterForm, modalElement])

  const modalTitle = intl.formatMessage({
    id: '47KLa4E4Le4vsciNwQlG',
    defaultMessage: 'Cruise ships',
    description: 'Modal title for cruise ships filter in the cruise offer or booking section',
  })
  const applyLabel = intl.formatMessage({
    id: 'ZJ3mNIXEN1vnESPskMnM',
    defaultMessage: 'Apply',
    description: 'Button text to apply cruise ships filter selections',
  })
  const resetLabel = countSelected ?
      intl.formatMessage(
        {
          id: 'dFGditRPXLLmiSWQEmUV',
          defaultMessage: 'Reset all ({count})',
          description: 'Button text to reset cruise ships filters with active filter count',
        },
        { count: countSelected },
      ) :
      intl.formatMessage({
        id: '1lObjKTCh2LRvzV5RRQ4',
        defaultMessage: 'Reset all',
        description: 'Button text to reset cruise ships filters when no filters are selected',
      })

  return <Modal
    mode={drawerMode ? 'drawer' : 'default'}
    ref={containerRef}
    title={modalTitle}
    primaryActionText={applyLabel}
    onPrimaryActionClick={closeModal}
    secondaryActionText={resetLabel}
    onSecondaryActionClick={resetFilter}
  >
    <CruiseShipFilter
      cruiseShips={filters.cruiseShips}
      shipNameFacets={facets.shipNames}
      onChange={updateForm}
      fetching={fetching}
    />
  </Modal>
}

export default ModalCruiseSearchShipChip
